import React, { FC, useState } from 'react';
import { useGetProgramMasterData } from 'src/api/mutations/useGetProgramMasterData';
import './IncreaseStrengthSteps.scss'; // Reusing the same SCSS for consistency
import { ReactComponent as Recovery_focused_mobilityIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/recovery_focused_mobility.svg';
import { ReactComponent as Area_specific_mobilityIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/area_specific_mobility.svg';
import { ReactComponent as Full_body_mobilityIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/full_body_mobility.svg';
import { ReactComponent as Mobility_stabilityIcon } from '../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility_stability.svg';

interface MobilityStep3Props {
  value?: string;
  onNext?: (value: string) => void;
}

const iconMap: Record<string, React.ReactNode> = {
  full_body_mobility: <Full_body_mobilityIcon />,
  area_specific_mobility: <Area_specific_mobilityIcon />,
  mobility_stability: <Mobility_stabilityIcon />,
  recovery_focused_mobility: <Recovery_focused_mobilityIcon />,
};

// How should this goal be approached
// Choose the training type that best suits your client
export const MobilityStep3: FC<MobilityStep3Props> = ({ value, onNext }) => {
  const [selectedApproach, setSelectedApproach] = useState<string>(value || '');
  const { data: programMasterData, isLoading, isError } = useGetProgramMasterData();

  const groupData = programMasterData?.trainingGoalApproaches?.groups?.find(
    (g: any) => g.goalId === 'mobility',
  );

  const approaches = groupData?.options
    ? [...groupData.options].sort((a: any, b: any) => a.order - b.order)
    : [];

  if (isLoading) {
    return <div className="increase-strength-step">{'Loading options...'}</div>;
  }

  if (isError || !groupData) {
    return <div className="increase-strength-step">{'Error loading options.'}</div>;
  }

  return (
    <div className="increase-strength-step">
      <h2 className="step-title">{groupData?.title}</h2>
      <p className="step-subtitle">{groupData?.subtitle}</p>

      <div className="goal-buttons">
        {approaches.map((approach: any) => (
          <button
            key={approach.id}
            className={`goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`}
            onClick={() => {
              setSelectedApproach(approach.slug);
              if (onNext) onNext(approach.slug);
            }}
          >
            <div className="goal-icon">{iconMap[approach.id]}</div>
            <span className="goal-label">{approach.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
